<div class="flex flex-row full-grow-no-shrink-no-basis">
  <div class="main-scrolling-area flex flex-row justify-start items-start">
    <div class="floating-pagination flex flex-row justify-start items-center">
      <i *ngIf="canAddNewRow" class="fal fa-plus-circle m-r-18" (click)="addNewRecord()"></i>
      <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="conform-buttons m-r-12">
        <mat-button-toggle value="Confirmed"
                           [checked]="rowItem && rowItem.cells && rowItem.cells['Status'].value === 'Confirmed'"
                           (click)="changeConfirmationStatus('Confirmed')"><i class="fal fa-check"></i>
        </mat-button-toggle>
        <mat-button-toggle value="Discarded"
                           [checked]="rowItem && rowItem.cells && rowItem.cells['Status'].value === 'Discarded'"
                           (click)="changeConfirmationStatus('Discarded')"><i class="fal fa-times"></i>
        </mat-button-toggle>
      </mat-button-toggle-group>
      <i class="fal fa-arrow-to-left" [ngClass]="{'disiable': selectedIndex==0}" (click)="changePage(-1)"></i>

      <div class="content">{{selectedIndex + 1}} of {{items.length}}</div>
      <i class="fal fa-arrow-right" [ngClass]="{'disiable': selectedIndex+1==items.length}" (click)="changePage(1)"></i>

    </div>
    <div class="fixed-width-area flex flex-col">


      <div class="root-container w-p-100 flex flex-row justify-start items-start full-grow-no-shrink-no-basis">
        <mat-accordion class="full-grow-no-shrink-no-basis">

          <!-- #enddocregion basic-panel -->
          <mat-expansion-panel *ngFor="let section of sections; let i = index;" (opened)="section.panelOpenState = true"
                               (closed)="section.panelOpenState = false"
                               [expanded]="defaultExpansionPanelIndex==i ? true : section.panelOpenState">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{section?.title}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <particle-flow-chart-response-group-view
              *ngIf="sourceType && section.type=='Group' && section.questions.length>0" [section]="section"
              [surveyId]="surveyId" [sourceType]="sourceType" [rowItem]="rowItem"
              [fieldDefinitions]="fieldDefinitions">
            </particle-flow-chart-response-group-view>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>
